import localforage from 'localforage';
import {
  SUSCRIPTION_USER_SUCCESS,
  SET_NOTIFICATION_SUBSCRIPTIONID,
  LOCALFORAGE_NOTIFICATION_SUBSCRIPTIONID_KEY,
  UPDATE_USER_SUBSCRIPTION_SUCCESS,
  LOCALFORAGE_SUBSCRIPTIONID_ISUPDATED,
  RESET_USER_SUBSCRIPTION,
  LOCALFORAGE_SUBSCRIPTIONID_RESET,
  RESTORE_USER_SUBSCRIPTION_SUCCESS,
} from '../Notifications/constants';

// eslint-disable-next-line no-unused-vars
const localforageMiddleware = store => next => action => {
  if (typeof navigator !== 'undefined' && !navigator.cookieEnabled) {
    return next(action);
  }

  switch (action.type) {
    case RESET_USER_SUBSCRIPTION: {
      localforage.removeItem(LOCALFORAGE_SUBSCRIPTIONID_ISUPDATED).catch(err => {
        console.error(err); // eslint-disable-line no-console
      });
      localforage.removeItem(LOCALFORAGE_NOTIFICATION_SUBSCRIPTIONID_KEY).catch(err => {
        console.error(err); // eslint-disable-line no-console
      });

      localforage.setItem(LOCALFORAGE_SUBSCRIPTIONID_RESET, true).catch(err => {
        console.error(err); // eslint-disable-line no-console
      });

      break;
    }
    case SET_NOTIFICATION_SUBSCRIPTIONID: {
      const suscriptionId = action.data.id;
      localforage.setItem(LOCALFORAGE_NOTIFICATION_SUBSCRIPTIONID_KEY, suscriptionId).catch(err => {
        console.error(err); // eslint-disable-line no-console
      });

      break;
    }
    case SUSCRIPTION_USER_SUCCESS:
    case RESTORE_USER_SUBSCRIPTION_SUCCESS:
    case UPDATE_USER_SUBSCRIPTION_SUCCESS: {
      localforage
        .setItem(LOCALFORAGE_NOTIFICATION_SUBSCRIPTIONID_KEY, action.data.user.id)
        .catch(err => {
          console.error(err); // eslint-disable-line no-console
        });
      localforage.setItem(LOCALFORAGE_SUBSCRIPTIONID_ISUPDATED, true).catch(err => {
        console.error(err); // eslint-disable-line no-console
      });
      localforage.removeItem(LOCALFORAGE_SUBSCRIPTIONID_RESET).catch(err => {
        console.error(err); // eslint-disable-line no-console
      });

      break;
    }
    default:
      return next(action);
  }
  return next(action);
};

export default localforageMiddleware;



// WEBPACK FOOTER //
// ./app/middlewares/localforage.js